<template>
  <div>
    <h3>教练管理</h3>
    <el-button type="primary" @click="openAddDialog">新增教练</el-button>
    <el-table :data="tableData" border style="margin-top:20px">
      <el-table-column prop="id" label="ID" width="80"/>
      <el-table-column prop="name" label="教练姓名"/>
      <el-table-column prop="title" label="头衔"/>
      <el-table-column prop="city" label="城市"/>
      <el-table-column prop="status" label="状态">
        <template #default="scope">
          <el-tag :type="scope.row.status ? 'success' : 'info'">
            {{ scope.row.status === 1 ? '展示' : '隐藏' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button @click="openEdit(scope.row)">编辑</el-button>
          <el-button type="danger" @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑弹窗 -->
    <el-dialog v-model="dialogVisible" title="教练信息">
      <el-form :model="form">
        <el-form-item label="姓名">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="头像URL">
          <el-input v-model="form.avatar"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="form.gender">
            <el-option label="男" value="male"/>
            <el-option label="女" value="female"/>
          </el-select>
        </el-form-item>
        <el-form-item label="头衔">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="简介">
          <el-input v-model="form.intro" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="城市">
          <el-input v-model="form.city"></el-input>
        </el-form-item>
        <el-form-item label="是否展示">
          <el-select v-model="form.status">
            <el-option label="展示" :value="1"/>
            <el-option label="隐藏" :value="0"/>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { getCoachList, addCoach, editCoach, delCoach } from "../api";
export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      form: {}
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const res = await getCoachList()
      this.tableData = res.data.list
    },
    openAddDialog() {
      this.form = { status:1 }
      this.dialogVisible = true
    },
    openEdit(row) {
      this.form = {...row}
      this.dialogVisible = true
    },
    async submit() {
      if(this.form.id){
        await editCoach(this.form.id, this.form)
      }else{
        await addCoach(this.form)
      }
      this.dialogVisible = false
      this.loadData()
      this.$message.success("保存成功")
    },
    async del(id) {
      await delCoach(id)
      this.loadData()
      this.$message.success("删除成功")
    }
  }
}
</script>
